module.exports = __webpack_public_path__ + "img/card_bg.7580e136.svg";